import React from 'react';
import EditorToolsSpace, {HEIGHT} from "./editorToolsSpace";
import {Tooltip} from "antd";
import MoreTool from "./tools/moreTool/moreTool";

export const toolWidth = 22;
const simpleToolWidth = toolWidth;
const padding = 8;


/**
 * 两行的工具空间
 */
class TwoLinesEditorToolsSpace extends EditorToolsSpace{

    static defaultProps = {
        tools: []
    };

    getWidth(num){
        return (num - 1) * padding + simpleToolWidth * num;
    }

    renderTools = (tools, maxLength) => {
        if (tools && tools.length > 0) {
            return tools.map((item, index) => {
                if(index > maxLength - 1){
                    return null;
                }
                let width = simpleToolWidth;
                let margin = padding;
                if(index === 0){
                    margin = 0;
                }
                if(typeof item === "object"){
                    if(item.width){
                        width = this.getWidth(item.width);
                    }
                    let title = item.title;
                    let name = item.name;
                    return <Tooltip placement={"top"} title={title} key={index}><span width={width} style={{marginLeft:margin}}>
                        {this.getToolComponent(name, {width, editor:window.ueditor})}
                    </span></Tooltip>
                }
            })
        }
    };

    getMoreTool = (tools, maxLength)=>{
        let moreTools = [];
        let firstTools = tools[0];
        if(firstTools.length > maxLength){
            moreTools = firstTools.slice(maxLength);
        }
        if(tools.length > 1){
            let secondTools = tools[1];
            if(secondTools && secondTools.length > maxLength){
                let secondMoreTools = secondTools.slice(maxLength - 1);
                moreTools = [...moreTools, ...secondMoreTools];
            }
        }
        return moreTools;
    };

    renderMoreTool = (moreTools)=>{
        if(moreTools && moreTools.length > 0){
            return <div style={{float:"left",marginRight:10}}>
                <MoreTool ref={itemComponent =>{
                    this.pushComponent(itemComponent);
                }}>
                    {moreTools.map((item,index)=>{
                        let name = item.name;
                        let title = item.title;
                        return <div className={"selectList"}
                                    style={{lineHeight:2.5, padding:"0 10px", cursor:"pointer"}}
                                    onClick={()=>{
                                        let component = this.getComponentByName(name);
                                        if(component && component.onClick){
                                            component.onClick();
                                        }
                                    }}
                                    key={index}>{this.getToolComponent(name, {editor:window.ueditor})}<span style={{margin: 10}}>{title}</span></div>;
                    })}
                    <style>
                        {
                            '.selectList:hover {background: rgba(0, 80, 179, 0.04)}'
                        }
                    </style>
                </MoreTool>
            </div>
        }
    };

    render() {
        let tools = this.props.tools.content;
        if(!tools || tools.length === 0){
            return <div/>;
        }
        const height = HEIGHT / 2;
        let {maxLength} = this.props.tools;
        let moreTools = this.getMoreTool(tools, maxLength);
        return (<>
            <div style={{float:"left"}} width={this.getWidth(maxLength) + padding * 2}>
                <div style={{height:height, lineHeight:2.5, margin:`0 ${padding}px`}}>
                    {tools && tools.length >= 1 && (()=>{
                        let firstTools = tools[0];
                        return this.renderTools(firstTools, maxLength);
                    })()}
                </div>
                <div style={{height:height, margin:`0px ${padding}px`}}>
                    {tools && tools.length >= 2 && (()=>{
                        let secondTools = tools[1];
                        return this.renderTools(secondTools, maxLength);
                    })()}
                </div>
            </div>
                {this.renderMoreTool(moreTools)}
            </>
        );
    }

}

export default TwoLinesEditorToolsSpace;